import React, { useEffect, useRef, useState } from "react";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import notification from "../../Assets/Images/Header/notification-icon.svg";
import todo from "../../Assets/Images/Header/to-do-list-icon.svg";
import supportTicket from "../../Assets/Images/Revenue-management/support-ticket.svg";
import NavDropdown from "react-bootstrap/NavDropdown";
import Form from "react-bootstrap/Form";
import { Button } from "react-bootstrap";
import Select from "react-select";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { commonService } from "../../utils/commonService";
import HeaderToDoList from "./HeaderToDoList";
import { HubConnectionBuilder } from "@microsoft/signalr";
import { API_URL } from "../../utils/apiRoutes";
import { toast } from "react-toastify";
import NotificationList from "./NotificationList";
import userPlaceHolder from "../../Assets/Images/blank-user.svg";
import UserProfileUpdateModal from "./UserProfileUpdateModal";
import { apiCall } from "../../utils/axiosService";
import { apiResponse } from "../../utils/apiResponse";
import {
    setPropertyInRedux,
    setCrmPropertyInRedux,
    setAsOfDateForHeader,
    setDefaultAsOfDateForHeader,
    setUserRolePropertyList,
    setSidebarCollapse,
    setAllNotificationCount,
    setAllPropertyDetails,
    setBookingPaceMonth,
    setDefaultCurrency,
    setPropertyRateCount,
    setActiveCmList,
    setSelectedCm,
} from "../../utils/slices/headerPropertySlice";
import { useDispatch, useSelector } from "react-redux";
import DatePicker from "react-datepicker";
import { errorToastMessage } from "../../utils/toastMessage";
import editIcon from "../../Assets/Images/Action Icons/editaction1.svg";
import moment from "moment";
import hamBurgerMenu from "../../Assets/Images/hamBurgerMenu.svg";
import VoiceBot from "../CommonComponent/VoiceBot";
import SupportTicketFullscreenModal from "../SupportTicket/SupportTicketFullscreenModal";
import TwoFactorSetting from "./TwoFactorSetting";

function Header() {

    let userRights = "";
    let userRightsFromLocal = localStorage.getItem("userRights");
    if (userRightsFromLocal) {
        userRights = JSON.parse(commonService.getItem("userRights"));
    }

    const dispatch = useDispatch();
    const propertyDetailFromRTK = useSelector(
        (store) => store.headerProperty.propertyDetail
    );


    const crmPropertyDetailFromRTK = useSelector(
        (store) => store.headerProperty.crmPropertyDetail
    );
    const userDetail = commonService.getLoginUserData();
    const [showModal, setShowModal] = useState(false);
    const [showSupportTicketModal, setShowSupportTicketModal] = useState(false);
    const [showNotification, setShowNotification] = useState(false);
    const [profileUpdateModal, setProfileUpdateModal] = useState(false);
    const [propertyDetail, setPropertyDetail] = useState(null);
    const [propertySelcted, setPropertySelcted] = useState(
        propertyDetailFromRTK ? propertyDetailFromRTK?.propertyid : ""
    );


    const [TwoFactorEnableModal, setTwoFactorEnableModal] = useState(false);

    const [crmProperty, setCrmProperty] = useState(null);
    const [crmPropertySelcted, setCrmPropertySelcted] = useState(
        crmPropertyDetailFromRTK ? crmPropertyDetailFromRTK?.propertyid : ""
    );
    const [asOfDate, setAsOfDate] = useState(null);
    const minAsOfDateRef = useRef();
    const [selectedAsOfDate, setSelectedAsOfDate] = useState(null);
    const [notificationCount, setNotificationCount] = useState(null);
    const allCountRef = useRef();
    const notificationType = useSelector(
        (store) => store.headerProperty.allNotificationCount
    );
    const activeCmList = useSelector((store) => store.headerProperty.activeCmList);
    const selectedCm = useSelector((store) => store.headerProperty.selectedCm);

    const navigate = useNavigate();
    const location = useLocation();

    const openModal = () => setShowModal(true);
    const closeModal = () => setShowModal(false);

    const openSupportTicketModal = () => setShowSupportTicketModal(true);
    const closeSupportTicketModal = () => setShowSupportTicketModal(false);




    const closeTwoFactorEnableModal = () => {
        setTwoFactorEnableModal(false);
    };
    const closeProfileUpdateModal = () => {
        setProfileUpdateModal(false);
    };

    const closeNotificationModal = () => {
        setShowNotification(false);
    };

    const handleLogout = () => {
        commonService.LogOutToUser()
    };

    const handleActionLog = () => {
        navigate("/configuration/action-logs");
    };

    const handleSawitchUser = () => {
        window.location.href = commonService.getItem("MD") + "/userselection"
    };



    const getPropertyList = async (modulename) => {

        let propertyListResponse = await apiCall(
            {
                method: "POST",
                url:
                    API_URL.BASE_API_URL.UserManagement +
                    API_URL.USER_ROLE_PROPERTY.GET_LIST_BY_MODULE_AND_USER,
                body: {
                    userid: userDetail?.userid,
                    modulename: modulename,
                },
            },
            false
        );

        let response = apiResponse(false, propertyListResponse);

        if (response?.isValidate) {
            setPropertyDetail(response?.data?.data);
            let sameCurrency = true,
                currency = response?.data?.data?.[0]?.currency_term;
            for (let i = 0; i < response?.data?.data?.length; i++) {
                if (response?.data?.data?.[i]?.currency_term !== currency) {
                    sameCurrency = false;
                    break;
                }
            }
            commonService.setItem(
                "defaultCurrency",
                JSON.stringify({
                    currency: currency ? currency : "$",
                })
            );
            dispatch(setDefaultCurrency(currency ? currency : "$"));
            dispatch(setAllPropertyDetails(response?.data?.data));
            if (response?.data?.data) {
                let filterProp = response?.data?.data.filter((pd) => pd.propertyid === propertyDetailFromRTK?.propertyid);
                if (filterProp) {
                    if (filterProp.length === 0) {
                        localStorage.removeItem("property");
                        setPropertySelcted("");
                        dispatch(setPropertyInRedux(null));
                        dispatch(setAsOfDateForHeader(null));
                    }
                }
                else {
                    localStorage.removeItem("property");
                    setPropertySelcted("");
                    dispatch(setPropertyInRedux(null));
                    dispatch(setAsOfDateForHeader(null));
                    setPropertyDetail(null);
                    dispatch(setAllPropertyDetails(null));
                }
            }
        }

        if (!response?.isValidate) {
            localStorage.removeItem("property");
            setPropertySelcted("");
            dispatch(setPropertyInRedux(null));
            dispatch(setAsOfDateForHeader(null));
            setPropertyDetail(null);
            dispatch(setAllPropertyDetails(null));
        }
    };

    const getPropertyListByUserId = async () => {

        let propertyListByUserIdReponse = await apiCall(
            {
                method: "POST",
                url:
                    API_URL.BASE_API_URL.UserManagement +
                    API_URL.USER_ROLE_PROPERTY.GET_LIST_BY_MODULE_AND_USER,
                body: {
                    userid: userDetail?.userid,
                    modulename: "CRM",
                },
            },
            false
        );

        let response = apiResponse(false, propertyListByUserIdReponse);

        if (response?.isValidate) {
            setCrmProperty(response?.data?.data);
            if (
                !crmPropertyDetailFromRTK ||
                crmPropertyDetailFromRTK?.propertyid === ""
            ) {
                let allPropertyId = "";
                response?.data?.data?.map((item, index) => {
                    allPropertyId += `${item?.propertyid},`;
                });
                commonService.setItem(
                    "crmProperty",
                    JSON.stringify({
                        propertyid: "",
                        propertycode: "ALL",
                        propertyname: "ALL",
                        allPropertyId,
                    })
                );

                setCrmPropertySelcted("");
                dispatch(
                    setCrmPropertyInRedux({
                        propertyid: "",
                        propertycode: "ALL",
                        propertyname: "ALL",
                        allPropertyId,
                    })
                );
            }
        }

        if (!response?.isValidate) {
            setCrmProperty(null);
        }
    };

    const getAsOfDate = async (propertyCode) => {
        if (propertyCode) {
            let asOfDateResponse = await apiCall(
                {
                    method: "POST",
                    url: API_URL.BASE_API_URL.SnapShot + API_URL.AS_OF_DATE.AS_OF_DATE,
                    body: { propertyCode: propertyCode },
                },
                false
            );

            if (asOfDateResponse?.status_code === 0) {
                return errorToastMessage(asOfDateResponse?.message);
            } else if (asOfDateResponse?.status_code === 1) {
                setAsOfDate(
                    asOfDateResponse?.data?.[0]?.last_data_refresh
                        ? asOfDateResponse?.data?.[0]?.last_data_refresh
                        : ""

                );
                let date = moment(
                    asOfDateResponse?.data?.[0]?.last_data_refresh
                ).subtract(90, "d");
                minAsOfDateRef.current = date;
                setSelectedAsOfDate(
                    asOfDateResponse?.data?.[0]?.last_data_refresh
                        ? asOfDateResponse?.data?.[0]?.last_data_refresh
                        : ""

                );
                dispatch(
                    setAsOfDateForHeader(
                        asOfDateResponse?.data?.[0]?.last_data_refresh
                            ? asOfDateResponse?.data?.[0]?.last_data_refresh
                            : ""

                    )
                );
                dispatch(
                    setDefaultAsOfDateForHeader(
                        asOfDateResponse?.data?.[0]?.last_data_refresh
                            ? asOfDateResponse?.data?.[0]?.last_data_refresh
                            : ""

                    )
                );
            }
            else {
                commonService.LogOutToUser();
            }
            //else if (asOfDateResponse?.message === "Request failed with status code 403" || asOfDateResponse?.message === "Token missing. Please provide a Bearer token.") {
            //    commonService.LogOutToUser()
            //}
        }
    };


    const getUserRolePropertyList = async (modulename) => {
        let userRolePropertyResponse = await apiCall(
            {
                method: "POST",
                url:
                    API_URL.BASE_API_URL.UserManagement +
                    API_URL.USER_ROLE_PROPERTY.GET_LIST_BY_PROPERTY_AND_MODULE,
                body: {
                    propertyid: parseInt(propertyDetailFromRTK?.propertyid),
                    modulename: modulename,
                },
            },
            false
        );
        let response = apiResponse(false, userRolePropertyResponse);
        if (response?.isValidate) {
            let responseData = response?.data?.data;
            responseData.unshift({
                displayname: "All",
                userid: responseData.map((d) => d.userid),
            });
            dispatch(setUserRolePropertyList(responseData));
        } else {
            dispatch(setUserRolePropertyList(null));
        }
    };

    const rateCounts = useSelector(
        (store) => store.headerProperty.defaultRateCounts
    );
    const UnmappedRatePlanCodeData = rateCounts ? [{ unmapped: rateCounts }] : null;

    const get_unmappedrate_plancode_data = async () => {
        let ratePlanListResponse = await apiCall(
            {
                method: "POST",
                url:
                    API_URL.BASE_API_URL.RevenueManagement +
                    API_URL.REVENUE_RATE_PLAN.GET_UNMAPPEDRATE_PLANCODE_DATA,
                body: {
                    propertyid: parseInt(propertyDetailFromRTK?.propertyid),
                },
            },
            false
        );

        let response = apiResponse(false, ratePlanListResponse);

        if (response?.isValidate) {
            const unmappedCount = response?.data?.data?.[0]?.unmapped || 0;
            localStorage.setItem("rateCounts", unmappedCount);
            dispatch(setPropertyRateCount(unmappedCount));
        }
    };

    const getNotificationCount = async () => {
        let notificationCountResponse = await apiCall(
            {
                method: "POST",
                url:
                    API_URL.BASE_API_URL.Notification +
                    API_URL.NOTIFICATION.GET_NOTIFICATION_READ_COUNT,
                body: {
                    propertycode: propertyDetailFromRTK
                        ? propertyDetailFromRTK?.propertycode
                        : "",
                },
            },
            true
        );

        let response = apiResponse(false, notificationCountResponse);

        if (response?.isValidate) {
            let allCount = response?.data?.data?.filter(
                (x) => x?.associationtype === "All"
            );
            allCountRef.current = allCount?.[0]?.noofcount
                ? allCount?.[0]?.noofcount
                : 0;
            dispatch(setAllNotificationCount(response?.data?.data));
            setNotificationCount(response?.data?.data);
        }

        if (!response?.isValidate) {
            setNotificationCount(null);
        }
    };

    useEffect(() => {
        //const currentPath = window?.location?.pathname?.toLowerCase() || "";
        ////if (currentPath.includes("/support-ticket")) {
        ////    return;
        ////}

        //let userHaveAccess = userRights?.usermodule?.filter((x) => {
        //    if (currentPath.includes(x.modulename?.toLowerCase())) {
        //        return x;
        //    }
        //});

        //if (userHaveAccess?.length <= 0) {
        //    navigate("/dashboard");
        //}
    }, []);

    const fetchCm = async () => {
        if (location.pathname.toLowerCase().includes("/ratedistribution/") && propertyDetailFromRTK?.propertycode) {
            let cmResponse = await apiCall(
                {
                    method: "POST",
                    url: API_URL.BASE_API_URL.SnapShot + API_URL.RATE_DISTRIBUTION.GET_ACTIVE_CM_CONNECTION,
                    body: {
                        property_code: propertyDetailFromRTK.propertycode,
                    },
                },
                false
            );
            let response = apiResponse(false, cmResponse);
            if (response?.isValidate) {
                let dataFromApi = response?.data?.data?.summary || response?.data?.data || response?.data || [];
                if (!Array.isArray(dataFromApi)) {
                    if (dataFromApi.data && Array.isArray(dataFromApi.data)) {
                        dataFromApi = dataFromApi.data;
                    } else if (dataFromApi.summary && Array.isArray(dataFromApi.summary)) {
                        dataFromApi = dataFromApi.summary;
                    } else {
                        dataFromApi = [dataFromApi];
                    }
                }

                const connectedCms = dataFromApi.filter(d => d.status === 'connected').map(c => {
                    const CHANNEL_NAMES = {
                        cloudbeds: 'Cloudbeds',
                        siteminder: 'SiteMinder'
                    };
                    return {
                        id: c.cm_type,
                        name: c.cm_name || CHANNEL_NAMES[c.cm_type] || c.cm_type
                    };
                });

                dispatch(setActiveCmList(connectedCms));

                if (connectedCms.length > 0) {
                    const stillConnected = selectedCm ? connectedCms.find(c => c.id === selectedCm.id) : null;
                    if (!stillConnected) {
                        dispatch(setSelectedCm(connectedCms[0]));
                    }
                } else {
                    dispatch(setSelectedCm(null));
                }
            } else {
                dispatch(setActiveCmList([]));
                dispatch(setSelectedCm(null));
            }
        }
    };

    const cmRefreshTrigger = useSelector((store) => store.headerProperty.cmRefreshTrigger);

    useEffect(() => {
        fetchCm();
    }, [propertyDetailFromRTK, location.pathname, dispatch, cmRefreshTrigger]);



    useEffect(() => {

        commonService.fnSetMainAndSubDomain();

        setPropertySelcted(propertyDetailFromRTK ? propertyDetailFromRTK?.propertyid : "")
        if (userDetail != null && userDetail.userid !== 0) {
            const connect = new HubConnectionBuilder()
                .withUrl(API_URL.BASE_API_URL.LogAndMessage, { withCredentials: false })
                .withAutomaticReconnect()
                .build();

            connect
                .start()
                .then(() => {
                    /*  connect.send("connect", userDetail.userid, commonService.getItem("token"));*/
                    connect.send("connect", userDetail.userid);
                    connect.on("getnotification", (data) => {
                        if (
                            document.querySelectorAll('[data_details="' + data.details + '"]')
                                .length === 0
                        ) {
                            let IsDisplay = true;
                            if (window.location.indexOf("revenue/rate-shop") > 0 || window.location.indexOf("revenue/rate-shop/rate-shop-table-view") > 0) {
                                if (data.associationtype === "On Demand Rateshop") {
                                    IsDisplay = false;
                                }
                            }
                            if (IsDisplay) {

                                toast.success(<>
                                    <div className="card-title h6" data_details={data.details}>
                                        <b>{data.title}</b>
                                    </div>
                                    <p className="card-text pt-2">{data.details}</p>
                                </>, {
                                    position: "top-right",
                                    autoClose: 3000,
                                    hideProgressBar: false,
                                    closeOnClick: true,
                                    pauseOnHover: true,
                                    draggable: true,
                                    progress: undefined,
                                    theme: "light",
                                    pauseOnFocusLoss: false,
                                });
                            }
                        }
                    });
                })
                .catch((error) => { });
        }

        if (window?.location?.href?.includes("/revenue/")) {
            getPropertyList("Revenue");

            if (propertyDetailFromRTK) {
                get_unmappedrate_plancode_data();
                getUserRolePropertyList("Revenue");
                getAsOfDate(propertyDetailFromRTK?.propertycode);
            }
        }

        if (window?.location?.href?.includes("/rateshop/")) {
            getPropertyList("Rateshop");

            if (propertyDetailFromRTK) {
                getUserRolePropertyList("Rateshop");
                getAsOfDate(propertyDetailFromRTK?.propertycode);
            }
        }

        // Need To Be Update After module Assign
        if (window?.location?.href?.includes("/ratedistribution/")) {
            // getPropertyList("Ratedistribution");
            getPropertyList("Revenue");

            if (propertyDetailFromRTK) {
                // getUserRolePropertyList("Ratedistribution");
                getUserRolePropertyList("Rateshop");
                getAsOfDate(propertyDetailFromRTK?.propertycode);
            }
        }

        if (window?.location?.href?.includes("/crm/")) {
            getPropertyListByUserId();
            if (
                crmPropertyDetailFromRTK &&
                crmPropertyDetailFromRTK?.propertyid !== ""
            ) {
                getAsOfDate(crmPropertyDetailFromRTK?.propertycode);
            }
        }

        getNotificationCount();
    }, []);

    useEffect(() => {
        setPropertySelcted(propertyDetailFromRTK ? propertyDetailFromRTK?.propertyid : "")
        getAsOfDate(propertyDetailFromRTK?.propertycode);
        getNotificationCount();
    }, [propertyDetailFromRTK]);

    //useEffect(() => {
    //    setPropertySelcted(propertyDetailFromRTK ? propertyDetailFromRTK?.propertyid : "")
    //    if (userDetail != null && userDetail.userid !== 0) {
    //        const connect = new HubConnectionBuilder()
    //            .withUrl(API_URL.BASE_API_URL.LogAndMessage, { withCredentials: false })
    //            .withAutomaticReconnect()
    //            .build();

    //        connect
    //            .start()
    //            .then(() => {
    //                /*  connect.send("connect", userDetail.userid, commonService.getItem("token"));*/
    //                connect.send("connect", userDetail.userid);
    //                connect.on("getnotification", (data) => {
    //                    if (
    //                        document.querySelectorAll('[data_details="' + data.details + '"]')
    //                            .length === 0
    //                    ) {
    //                        let IsDisplay = true;
    //                        if (window.location.indexOf("revenue/rate-shop") > 0 || window.location.indexOf("revenue/rate-shop/rate-shop-table-view") > 0) {
    //                            if (data.associationtype === "On Demand Rateshop") {
    //                                IsDisplay = false;
    //                            }
    //                        }
    //                        if (IsDisplay) {

    //                            toast.success(<>
    //                                <div className="card-title h6" data_details={data.details}>
    //                                    <b>{data.title}</b>
    //                                </div>
    //                                <p className="card-text pt-2">{data.details}</p>
    //                            </>, {
    //                                position: "top-right",
    //                                autoClose: 3000,
    //                                hideProgressBar: false,
    //                                closeOnClick: true,
    //                                pauseOnHover: true,
    //                                draggable: true,
    //                                progress: undefined,
    //                                theme: "light",
    //                                pauseOnFocusLoss: false,
    //                            });
    //                        }
    //                    }
    //                });
    //            })
    //            .catch((error) => { });
    //    }

    //    if (window?.location?.href?.includes("/revenue/")) {
    //        getPropertyList();

    //        if (propertyDetailFromRTK) {
    //            get_unmappedrate_plancode_data();
    //            getUserRolePropertyList();
    //            getAsOfDate(propertyDetailFromRTK?.propertycode);
    //        }
    //    }

    //    if (window?.location?.href?.includes("/crm/")) {
    //        getPropertyListByUserId();
    //        if (
    //            crmPropertyDetailFromRTK &&
    //            crmPropertyDetailFromRTK?.propertyid != ""
    //        ) {
    //            getAsOfDate(crmPropertyDetailFromRTK?.propertycode);
    //        }
    //    }

    //    if (
    //        window?.location?.href?.substring(
    //            window?.location?.href.lastIndexOf("/") + 1 === "Crm-Rateshop"
    //        ) ||
    //        window?.location?.href?.substring(
    //            window?.location?.href.lastIndexOf("/") + 1 === "crm-events"
    //        ) ||
    //        window?.location?.href?.substring(
    //            window?.location?.href.lastIndexOf("/") + 1 === "crm-rateiq"
    //        )
    //    ) {
    //        getPropertyList();
    //    }

    //    getNotificationCount();
    //}, [propertyDetailFromRTK]);


    return (
        <div className="header-main">
            <Container fluid>
                <Row className="header-row">
                    <Col xl={3} lg={1} className="header-left-col">
                        <div className="logo-sec d-flex">
                            <div className="logo-main">
                                <Link id={commonService.generateGlobalClickTrackerID("Header", "link-link", "")} to={`${commonService.getItem("MD")}/dashboard`}>
                                    <img src={commonService.GetLogo().logo} alt="logo" title="Switchboard" />
                                </Link>
                            </div>
                            <div
                                className=""
                                style={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "20px",
                                    background: "#f2f4fc",
                                    width: "76%",
                                }}
                            >
                                <h2 className="logo-name">{commonService.GetLogoHeaderTitle()}</h2>
                                {commonService.GetLogoHeaderTitle() !== "Switchboard" && (
                                    <img id={commonService.generateGlobalClickTrackerID("Header", "hamburgermenu", "")}
                                        style={{
                                            height: "20px",
                                            marginRight: "25px",
                                            cursor: "pointer",
                                        }}
                                        onClick={() => {
                                            dispatch(setSidebarCollapse());
                                        }}
                                        src={hamBurgerMenu}
                                    />
                                )}
                            </div>
                        </div>
                    </Col>
                    <Col xl={9} lg={11} className="header-right-col">
                        <div className="header-right d-flex justify-content-between align-items-center gap-2">
                            <div className="d-flex align-items-center gap-4">
                                <div className="header-select-property"  >
                                    {(window?.location?.href?.includes("/revenue/") || window?.location?.href?.includes("/rateshop/") || window?.location?.href?.includes("/ratedistribution/")) && (
                                        <div className="multiselector" dataselected={propertyDetailFromRTK?.propertyname ? propertyDetailFromRTK?.propertyname : ""} id="mainheaderpropertyselection">
                                            <Select id={commonService.generateGlobalClickTrackerID("Header", "select-onchange", "")}

                                                isClearable
                                                isSearchable
                                                className="width350 dropdown-font-size"
                                                value={
                                                    propertySelcted
                                                        ? {
                                                            label: propertyDetail?.find((x) => x?.propertyid === propertySelcted)?.propertyname,
                                                            value: propertySelcted,
                                                        }
                                                        : null
                                                }
                                                onChange={(selectedOption) => {
                                                    if (!selectedOption) {
                                                        localStorage.removeItem("property");
                                                        setPropertySelcted("");
                                                        dispatch(setPropertyInRedux(null));
                                                        dispatch(setAsOfDateForHeader(null));
                                                    } else {
                                                        let findProperty = propertyDetail?.filter(
                                                            (x) => x?.propertyid === selectedOption.value
                                                        );
                                                        commonService.setItem(
                                                            "property",
                                                            JSON.stringify(findProperty?.[0])
                                                        );

                                                        setPropertySelcted(selectedOption.value);
                                                        dispatch(setPropertyInRedux(findProperty?.[0]));
                                                        // getAsOfDate();
                                                    }

                                                    if (window.SuperMiaVoice?.endCall) {
                                                        window.SuperMiaVoice.endCall();
                                                    }

                                                }}
                                                options={
                                                    propertyDetail?.map((item) => ({
                                                        label: item?.propertyname,
                                                        value: item?.propertyid,
                                                    })) || []
                                                }
                                                placeholder="Select Property"
                                            />
                                        </div>
                                    )}

                                    {window?.location?.href?.includes("/crm/") && (
                                        <div className="multiselector" dataselected={crmPropertyDetailFromRTK?.propertyname ? crmPropertyDetailFromRTK?.propertyname : ""} id="mainheaderpropertyselection">
                                            <Select id={commonService.generateGlobalClickTrackerID("Header", "select-onchange", "")}
                                                isClearable
                                                isSearchable
                                                className="width350 dropdown-font-size"
                                                value={
                                                    crmPropertySelcted
                                                        ? {
                                                            label: crmProperty?.find((x) => x?.propertyid === crmPropertySelcted)?.propertyname,
                                                            value: crmPropertySelcted,
                                                        }
                                                        : null
                                                }
                                                onChange={(selectedOption) => {
                                                    if (!selectedOption) {
                                                        let allPropertyId = "";
                                                        crmProperty?.map((item, index) => {
                                                            allPropertyId += `${item?.propertyid},`;
                                                        });
                                                        commonService.setItem(
                                                            "crmProperty",
                                                            JSON.stringify({
                                                                propertyid: "",
                                                                propertycode: "ALL",
                                                                propertyname: "ALL",
                                                                allPropertyId,
                                                            })
                                                        );

                                                        setCrmPropertySelcted("");
                                                        dispatch(
                                                            setCrmPropertyInRedux({
                                                                propertyid: "",
                                                                propertycode: "ALL",
                                                                propertyname: "ALL",
                                                                allPropertyId,
                                                            })
                                                        );
                                                    } else {
                                                        let findProperty = crmProperty?.filter(
                                                            (x) => x?.propertyid === selectedOption.value
                                                        );
                                                        commonService.setItem(
                                                            "crmProperty",
                                                            JSON.stringify(findProperty?.[0])
                                                        );

                                                        setCrmPropertySelcted(selectedOption.value);
                                                        dispatch(setCrmPropertyInRedux(findProperty?.[0]));
                                                    }
                                                }}
                                                options={
                                                    crmProperty?.map((item) => ({
                                                        label: item?.propertyname,
                                                        value: item?.propertyid,
                                                    })) || []
                                                }
                                                placeholder="Select Property"
                                            />
                                        </div>
                                    )}
                                </div>
                                {window?.location?.href?.includes("/revenue/") &&
                                    propertyDetailFromRTK && (
                                        <Link id={commonService.generateGlobalClickTrackerID("Header", "link-link", "")}
                                            className="headerEditIcon customHeaderIcon"
                                            to={`/revenue/property-setting/${propertyDetailFromRTK?.propertyid}`}
                                            state={{
                                                propertyData: propertyDetailFromRTK,
                                                rateCount: UnmappedRatePlanCodeData?.[0]?.unmapped
                                            }}
                                        >
                                            <img src={editIcon} />
                                        </Link>
                                    )}
                                {window?.location?.href?.includes("/rateshop/") &&
                                    propertyDetailFromRTK && (
                                        <Link id={commonService.generateGlobalClickTrackerID("Header", "link-link", "")}
                                            className="headerEditIcon customHeaderIcon"
                                            to={`/rateshop/property-setting/${propertyDetailFromRTK?.propertyid}`}
                                            state={{
                                                propertyData: propertyDetailFromRTK,
                                                rateCount: UnmappedRatePlanCodeData?.[0]?.unmapped
                                            }}
                                        >
                                            <img src={editIcon} />
                                        </Link>
                                    )}
                                {location.pathname.toLowerCase().includes("/ratedistribution/") && activeCmList && activeCmList.length > 0 && (
                                    <div className="multiselector" style={{ marginLeft: "10px" }}>
                                        <Select
                                            isClearable
                                            isSearchable
                                            className="width250 dropdown-font-size"
                                            value={
                                                selectedCm
                                                    ? {
                                                        label: selectedCm.name,
                                                        value: selectedCm.id,
                                                    }
                                                    : null
                                            }
                                            onChange={(selectedOption) => {
                                                if (!selectedOption) {
                                                    dispatch(setSelectedCm(null));
                                                } else {
                                                    const cm = activeCmList.find((c) => c.id === selectedOption.value);
                                                    if (cm) dispatch(setSelectedCm(cm));
                                                }
                                            }}
                                            options={activeCmList.map((item) => ({
                                                label: item.name,
                                                value: item.id,
                                            }))}
                                            placeholder="Select Channel Manager"
                                        />
                                    </div>
                                )}
                                {(window?.location?.href?.includes("/revenue/") || window?.location?.href?.includes("/rateshop/") || window?.location?.href?.includes("/ratedistribution/")) && (
                                    <div className="header-asof-date">
                                        <DatePicker

                                            className="width150"
                                            id="asOfDate"
                                            placeholderText="As Of Date"
                                            maxDate={asOfDate ? new Date(asOfDate) : ""}
                                            minDate={
                                                minAsOfDateRef.current
                                                    ? new Date(minAsOfDateRef.current)
                                                    : ""
                                            }
                                            selected={
                                                propertySelcted
                                                    ? selectedAsOfDate
                                                        ? commonService.convertDateInTimezone(
                                                            selectedAsOfDate
                                                        )
                                                        : ""
                                                    : ""
                                            }
                                            onChange={(date) => {
                                                if (date !== null && date !== "") {
                                                    let month =
                                                        date.getMonth() + 1 > 9
                                                            ? date.getMonth() + 1
                                                            : `0${date.getMonth() + 1}`;
                                                    let dateFormat =
                                                        date?.getDate() > 9
                                                            ? date.getDate()
                                                            : `0${date.getDate()}`;
                                                    let selectedDate = `${date.getFullYear()}-${month}-${dateFormat}`;
                                                    setSelectedAsOfDate(selectedDate);
                                                    dispatch(setAsOfDateForHeader(selectedDate));
                                                    dispatch(setBookingPaceMonth(""));
                                                }
                                            }}
                                            disabled={
                                                window?.location?.href?.includes("/revenue/event")
                                                    ? true
                                                    : false
                                            }
                                        />
                                    </div>
                                )}
                            </div>

                            <div className="right-menu d-flex align-items-center justify-content-end">

                                <div className="header-icons">
                                    <ul className="list-unstyled p-0 m-0">
                                        <li>
                                            <Button id={commonService.generateGlobalClickTrackerID("Header", "button-onclick", "")}
                                                className="header-notification header-btn position-relative"
                                                onClick={() => setShowNotification(true)}
                                            >
                                                <img src={notification} alt="notification" />

                                                <span
                                                    style={{
                                                        color: "#fff",
                                                        fontSize: "8px",
                                                        borderRadius: "10px",
                                                        background: "#3565FC",
                                                        position: "absolute",
                                                        padding: "2px 5px",
                                                        top: "-5px",
                                                        left: "calc(100% - 10px)",
                                                        boxShadow: "0px 1px 8px 0px rgba(12, 0, 0, 0.08)",
                                                    }}
                                                >
                                                    {commonService.getAmountInCompactFormat(notificationType
                                                        ? notificationType?.filter(
                                                            (x) => x?.associationtype === "All"
                                                        )?.[0]?.noofcount
                                                        : 0)}
                                                </span>
                                            </Button>
                                        </li>
                                        <li>
                                            <Button id={commonService.generateGlobalClickTrackerID("Header", "button-onclick", "")}
                                                className="header-to-do header-btn"
                                                onClick={openModal}
                                            >
                                                <img src={todo} alt="to-do" />
                                            </Button>
                                        </li>
                                        <li>
                                            <Button id={commonService.generateGlobalClickTrackerID("Header", "button-onclick", "support-ticket")}
                                                className="header-to-do header-btn"
                                                title="Support Tickets"
                                                onClick={openSupportTicketModal}
                                            >
                                                <img src={supportTicket} alt="support ticket" />
                                            </Button>
                                        </li>
                                    </ul>
                                </div>
                                <div className="header-drop-down d-flex align-items-center">
                                    <img
                                        className="header-avtar"
                                        src={
                                            userDetail?.profilepic
                                                ? userDetail?.profilepic
                                                : userPlaceHolder
                                        }
                                        alt=""
                                    />
                                    <NavDropdown
                                        id="nav-dropdown-dark-example"
                                        title={userDetail?.displayname}
                                    >
                                        <NavDropdown.Item id={commonService.generateGlobalClickTrackerID("Header", "user-profile", "")}
                                            onClick={() => {
                                                setProfileUpdateModal(true);
                                            }}
                                        >
                                            User Profile
                                        </NavDropdown.Item>

                                        <NavDropdown.Item id={commonService.generateGlobalClickTrackerID("Header", "user-profile", "")}
                                            onClick={() => {
                                                setTwoFactorEnableModal(true);
                                            }}
                                        >
                                            Two Factor Setting
                                        </NavDropdown.Item>

                                        <NavDropdown.Item id={commonService.generateGlobalClickTrackerID("Header", "action-log", "")}
                                            onClick={() => {
                                                handleActionLog();
                                            }}
                                        >
                                            Action Log
                                        </NavDropdown.Item>
                                        <NavDropdown.Item id={commonService.generateGlobalClickTrackerID("Header", "sawitch-user", "")}
                                            onClick={() => {
                                                handleSawitchUser();
                                            }}
                                        >
                                            Switch User
                                        </NavDropdown.Item>
                                        <NavDropdown.Item id={commonService.generateGlobalClickTrackerID("Header", "log-out", "")}
                                            onClick={() => {
                                                handleLogout();
                                            }}
                                        >
                                            Log Out
                                        </NavDropdown.Item>
                                    </NavDropdown>
                                </div>
                            </div>
                        </div>
                    </Col>
                </Row>
            </Container>
            {showNotification && (
                <NotificationList
                    showSideBar={showNotification}
                    closeSideBar={closeNotificationModal}
                />
            )}
            {profileUpdateModal && (
                <UserProfileUpdateModal
                    showModal={profileUpdateModal}
                    closeModal={closeProfileUpdateModal}
                />
            )}

            {TwoFactorEnableModal && (
                <TwoFactorSetting
                    showModal={TwoFactorEnableModal}
                    closeModal={closeTwoFactorEnableModal}
                />
            )}

            {showModal && (
                <HeaderToDoList show={showModal} handleClose={closeModal} />
            )}
            <SupportTicketFullscreenModal
                show={showSupportTicketModal}
                onHide={closeSupportTicketModal}
            />

            {
                propertySelcted === 101 && userDetail && userDetail.userid === 49 && userDetail.clientid === 1 &&
                <VoiceBot initialX={"96%"} initialY={"2%"} />
            }

        </div>


    );
}

export default Header;
